<template>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 offset-md-1 offset-lg-2">
            <span class="title">Kontakt</span>
            <br/><br/>
            <p>Rechtsanwalt Christ</p>
            <p>Hattinger Straße 57</p>
            <p>44789 Bochum</p>
            <p><b>Tel: </b><a href="tel:023441482604"><b>0234 414 826-04</b></a></p>
            <p><b>Fax: 0234 414 826-05</b></p>
            <p><a href="mailto:christ@christ-recht.de">christ@christ-recht.de</a></p>
        </div>
        <div class="col-12 col-sm-6 col-md-6">
            <span class="title"></span>
            <br/><br class="visible-sm visible-md visible-lg"/>
            <p>Aufgrund von Gerichtsterminen oder wegen sonstiger Termine kann nicht jedes Telefonat sofort persönlich entgegengenommen werden. </p>
            <p>Bei Nachrichten auf dem Anrufbeantworter rufe ich selbstverständlich schnellstmöglich zurück.</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Contact.vue"
    }
</script>

<style scoped>

</style>